function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Order Expiration Modal
 * Self-contained component that shows an expiration modal when the order times out
 * 
 */
import * as React from 'react';
import { connect } from 'react-redux';
import ExpiredModal from '../expired-modal/ExpiredModal';
import { deleteAll } from '../../actions/';
import { isOrderExpired, getTimeUntilExpiration } from '../../functions/orderExpiration';
import { jsx as _jsx } from "react/jsx-runtime";
export class OrderExpirationModal extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "expirationTimerId", null);
    /**
     * Set up timer to show expiration modal when order expires
     */
    _defineProperty(this, "setupExpirationTimer", () => {
      const {
        application
      } = this.props;
      if (!application?.created_at) return;

      // Check if already expired
      if (isOrderExpired(application.created_at)) {
        this.setState({
          showExpiredModal: true
        });
        return;
      }

      // Set timer for when order will expire
      const msUntilExpiration = getTimeUntilExpiration(application.created_at);
      if (msUntilExpiration > 0) {
        this.expirationTimerId = setTimeout(() => {
          this.setState({
            showExpiredModal: true
          });
        }, msUntilExpiration);
      }
    });
    /**
     * Handle expired modal action - clear state and redirect to referrer
     */
    _defineProperty(this, "handleExpiredAction", () => {
      const {
        application,
        deleteAll
      } = this.props;
      deleteAll();
      window.location.href = application.referrer || '/';
    });
    this.state = {
      showExpiredModal: false
    };
  }
  componentDidMount() {
    this.setupExpirationTimer();
  }
  componentWillUnmount() {
    if (this.expirationTimerId) {
      clearTimeout(this.expirationTimerId);
    }
  }
  render() {
    const {
      showExpiredModal
    } = this.state;
    return /*#__PURE__*/_jsx(ExpiredModal, {
      show: showExpiredModal,
      onAction: this.handleExpiredAction
    });
  }
}
_defineProperty(OrderExpirationModal, "defaultProps", {
  application: {
    created_at: null,
    referrer: '/'
  }
});
const mapStateToProps = ({
  application
}) => {
  return {
    application
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteAll: () => {
      dispatch(deleteAll());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderExpirationModal);